<template>
  <v-footer class="font-weight-medium" dark>
    <v-container>
      <v-row>
        <v-col class="text-center text-h4"><v-btn rounded elevation="2" color="red" large href="https://www.mi-sos.org/shop" >Get your mi-SOS wearable now</v-btn></v-col>
      </v-row>
    </v-container>
    <v-col class="text-center" cols="12">mi-SOS &copy; {{ new Date().getFullYear() }} All rights<br>
    <a href="https://www.mi-sos.org/privacy-policy" class="text-decoration-none" _blank>Privacy Policy</a> |  <a href="https://www.mi-sos.org/terms-and-conditions" class="text-decoration-none">Terms & Conditions</a></v-col>
    
  </v-footer>
</template>

<script>
export default {};
</script>

<style>
</style>